module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1527-c2fc16db3d9ad9abfe406d94ff340a58.png";